import { render, staticRenderFns } from "./CartDrawer.vue?vue&type=template&id=f872756c&scoped=true"
import script from "./CartDrawer.vue?vue&type=script&lang=js"
export * from "./CartDrawer.vue?vue&type=script&lang=js"
import style0 from "./CartDrawer.vue?vue&type=style&index=0&id=f872756c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872756c",
  null
  
)

export default component.exports